import { render } from "./App.vue?vue&type=template&id=3f9cba1e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3f9cba1e&lang=scss"
script.render = render

export default script